export default __webpack_public_path__ + "static/media/(25).a65f2ad7.jpeg";